import { createCustomAction } from 'typesafe-actions';

import { CanvasIdea, IdeasSource } from './typings';

export const fetchIdeasSuccess = createCustomAction('@canvasIdeas/FETCH_IDEAS_SUCCESS', type => {
    return (url: string, ideaId: string, ideasList: CanvasIdea[]) => ({ type, url, ideaId, ideasList });
});

export const fetchIdeasError = createCustomAction('@canvasIdeas/FETCH_IDEAS_ERROR', type => {
    return (message: string) => ({ type, message });
});

export const increaseFetchIdeasStep = createCustomAction('@canvasIdeas/INCREASE_FETCH_IDEAS_STEP', type => {
    return () => ({ type });
});

export const ideasUrlChange = createCustomAction('@canvasIdeas/IDEAS_URL_CHANGE', type => {
    return (url: string) => ({ type, url });
});

export const fetchIdeas = createCustomAction('@canvasIdeas/FETCH_IDEAS', type => {
    return (source: IdeasSource) => ({ type, source });
});

export const initIdeas = createCustomAction('@canvasIdeas/INIT', type => {
    return (ideaId: string) => ({ type, ideaId });
});

export type FetchIdeas = ReturnType<typeof fetchIdeas>;
type IncreaseFetchIdeasStep = ReturnType<typeof increaseFetchIdeasStep>;
type FetchIdeasSuccess = ReturnType<typeof fetchIdeasSuccess>;
type FetchIdeasError = ReturnType<typeof fetchIdeasError>;
type IdeasUrlChange = ReturnType<typeof ideasUrlChange>;

export type IdeasListAction =
    | FetchIdeas
    | ReturnType<typeof initIdeas>
    | IncreaseFetchIdeasStep
    | FetchIdeasSuccess
    | FetchIdeasError
    | IdeasUrlChange;
